import { TSideTabSchema } from "../types/global.types";

// JOURNEY ROUTES
const JOURNEY_TABS: TSideTabSchema[] = [
  {
    id: 1,
    code: "landing-page",
    path: "/landing-page",
    name: "Landing Page",
  },

  {
    id: 2,
    code: "input",
    name: "Input",
    subTabs: [
      {
        id: 21,
        code: "lead-details",
        path: "/input/lead-details",
        name: "Lead Details",
      },
      {
        id: 22,
        code: "select-plan",
        path: "/input/select-plan",
        name: "Select Plan",
      },
      {
        id: 23,
        code: "travel-details",
        path: "/input/travel-details",
        name: "Travel Details",
      },
      {
        id: 24,
        code: "life-details",
        path: "/input/life-details",
        name: "Life Details",
      },
      {
        id: 25,
        code: "location-details",
        path: "/input/location-details",
        name: "Location Details",
      },
      {
        id: 26,
        code: "property-details",
        path: "/input/property-details",
        name: "Property Details",
      },
      {
        id: 27,
        code: "professional-indemnity",
        path: "/input/professional-indemnity",
        name: "Professional Indemnity",
      },

      {
        id: 28,
        code: "select-members",
        path: "/input/select-members",
        name: "Select Members",
      },
      {
        id: 29,
        code: "select-plan-type",
        path: "/input/select-plan-type",
        name: "Select Plan Type",
      },
      {
        id: 30,
        code: "marine-details",
        path: "/input/marine-details",
        name: "Marine Details",
      },
      {
        id: 31,
        code: "input-transit-details",
        path: "/input/input-transit-details",
        name: "Transit Details",
      },
      {
        id: 32,
        code: "event-details",
        path: "/input/event-details",
        name: "Event Details",
      },
      {
        id: 33,
        code: "worker-details",
        path: "/input/worker-details",
        name: "Worker Details",
      },
      {
        id: 34,
        code: "fire-details",
        path: "/input/fire-details",
        name: "Fire Details",
      },
      {
        id: 34,
        code: "cyber-details",
        path: "/input/cyber-details",
        name: "Cyber Details",
      },
    ],
  },
  { code: "quotes", path: "/quotes", name: "Quotes", id: 3 },
  { code: "compare", path: "/compare", name: "Compare", id: 4 },
  {
    id: 5,
    code: "product-details",
    path: "/product-details",
    name: "Product Details",
  },
  {
    id: 6,
    name: "Proposal",
    code: "proposal",
    path: "/proposal",
    subTabs: [
      {
        id: 61,
        name: "Proposer Details",
        code: "proposer-details",
        path: "/proposal/proposer-details",
      },
      {
        id: 62,
        name: "Insured Details",
        code: "insured-details",
        path: "/proposal/insured-details",
      },
      {
        id: 63,
        name: "Insured Items",
        code: "insured-items",
        path: "/proposal/insured-items",
      },
      {
        id: 64,
        name: "Insured Pets",
        code: "insured pets",
        path: "/proposal/insured-pets",
      },
      {
        id: 65,
        name: "Business Details",
        code: "business-details",
        path: "/proposal/business-details",
      },
      {
        id: 66,
        name: "Transit Details",
        code: "transit-details",
        path: "/proposal/transit-details",
      },
      {
        id: 67,
        name: "CKYC details",
        code: "ckyc-details",
        path: "/proposal/ckyc-details",
      },
      {
        id: 68,
        name: "Member Details",
        code: "member-details",
        path: "/proposal/member-details",
      },
      {
        id: 69,
        name: "Cyber Questions",
        code: "cyber-questions",
        path: "/proposal/cyber-questions",
      },
      {
        id: 70,
        name: "TopUp Details",
        code: "topup-details",
        path: "/proposal/topup-details",
      },
      {
        id: 71,
        name: "Insured Travels",
        code: "insured-travels",
        path: "/proposal/insured-travels",
      },
    ],
  },
  {
    code: "proposal-summary",
    path: "/proposal-summary",
    name: "Proposal Summary",
    id: 7,
  },
  {
    id: 8,
    name: "Payment Gateway",
    code: "payment-gateway",
    path: "/payment-gateway",
  },
  {
    id: 9,
    name: "Thank You",
    code: "thank-you",
    path: "/thank-you",
  },
  {
    id: 10,
    name: "Business Quotes",
    code: "business-quotes",
    path: "/business-quotes",
  },
  { id: 11, name: "Shortlisted", code: "shortlisted", path: "/shortlisted" },
];

export { JOURNEY_TABS };
